import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1 className='text-danger text-center m-5'>Error: Page Not Found</h1>
        </div>
    );
};

export default NotFound;